import { h } from 'preact';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import CSSTransition from 'react-transition-group/CSSTransition';

// Utils
import {
  calcColumns,
  stepHasRequiredData,
  getStepWaitText,
} from '../../../utilities/form/formUtils';

// Constants
import { stepComponents } from '../../../constants/Steps';

// Components
import FormActions from '../../Form/FormActions';
import StepHeader from '../General/StepHeader';

const Price = ({
  componentProps,
  title,
  desc,
  submitText,
  dispatch,
  errors,
  handleSubmit,
  onBlur,
  onChange,
  setValues,
  touched,
  values,
  setFormValues,
  formActions,
  requiredData,
  userData,
  price,
  setFieldValue,
  initialValues,
}) => (
  <article className="step step--input">

    {(title || desc) && (
      <StepHeader title={title} desc={desc}/>
    )}

    {/* If there's any props */}
    {!isEmpty(componentProps) && (
      <div className="step__content">
        {componentProps.map(componentProp => {
          const inputParams = {
            'children': componentProps,
            'columns': calcColumns(componentProp),
            'isValid': (stepHasRequiredData(requiredData, userData, values)),
            ...componentProp,
            dispatch,
            errors,
            handleSubmit,
            onBlur,
            onChange,
            setFormValues,
            setValues,
            touched,
            values,
            price,
            userData,
            setFieldValue,
            initialValues,
          };
          const PriceComponent = stepComponents[componentProp.type];
          return (
            <CSSTransition
              in={componentProp.hidden !== true}
              timeout={300}
              classNames="slideInTop"
              unmountOnExit
            >
              <PriceComponent {...inputParams}/>
            </CSSTransition>
          );
        })}

        {/* Actions Button */}
        <FormActions
          formActions={formActions}
          submitText={submitText}
          isValid={stepHasRequiredData(requiredData, userData, values)}
          dispatch={dispatch}
          values={values}
          waitText={getStepWaitText(requiredData, userData, values)}
          setFieldValue={setFieldValue}
          setValues={setValues}
        />
      </div>

    )}

  </article>
);

export default Price;

Price.defaultProps = {
  title: null,
  desc: null,
  formActions: null,
  requiredData: {},
  userData: null,
};

Price.propTypes = {
  componentProps: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  setFormValues: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  submitText: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  formActions: PropTypes.array,
  requiredData: PropTypes.object,
  userData: PropTypes.object,
  title: PropTypes.string,
  desc: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Price/index.jsx